/* custom-goat.js — GOAT Fitness night mode toggle
 *
 * The mode itself is applied by a tiny inline script in layout/theme.liquid that
 * runs before first paint. This file only adds the button and handles clicks —
 * so if it fails to load, the site still renders in the visitor's saved mode
 * rather than flashing back to day.
 *
 * Behaviour:
 *   - Night mode is the default for every first-time visitor.
 *   - The only thing that overrides it is the visitor's own click, remembered
 *     in localStorage under "goat-theme". The OS setting is ignored on purpose.
 *   - The button shows the mode you would switch TO, not the current one.
 */
(function () {
  'use strict';

  var KEY = 'goat-theme';
  var root = document.documentElement;

  function current() {
    return root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
  }

  function apply(mode, persist) {
    root.setAttribute('data-theme', mode);
    if (persist) {
      try { localStorage.setItem(KEY, mode); } catch (e) { /* private mode */ }
    }
    document.querySelectorAll('.goat-theme-toggle').forEach(function (btn) {
      var next = mode === 'dark' ? 'day' : 'night';
      btn.setAttribute('aria-pressed', mode === 'dark' ? 'true' : 'false');
      btn.setAttribute('aria-label', 'Switch to ' + next + ' mode');
      btn.setAttribute('title', 'Switch to ' + next + ' mode');
    });
  }

  var ICONS =
    '<svg class="goat-icon-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>' +
    '<svg class="goat-icon-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>';

  function build() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'goat-theme-toggle';
    btn.innerHTML = ICONS;
    btn.addEventListener('click', function () {
      apply(current() === 'dark' ? 'light' : 'dark', true);
    });
    return btn;
  }

  function mount() {
    if (document.querySelector('.goat-theme-toggle')) return;

    // Sit alongside the existing header icons. Falls back to the header itself
    // if Dawn's markup ever changes, so the control never disappears silently.
    var host =
      document.querySelector('.header__icons') ||
      document.querySelector('.header__icon-list') ||
      document.querySelector('.header');
    if (!host) return;

    var btn = build();
    var search = host.querySelector('details, .header__icon--search');
    if (search && search.parentNode === host) host.insertBefore(btn, search);
    else host.insertBefore(btn, host.firstChild);

    apply(current(), false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  // The OS setting is deliberately NOT followed. The site opens in night mode
  // for everyone, and only the visitor's own click changes that. Watching
  // prefers-color-scheme here used to flip a first-time visitor on a light
  // phone straight back to day, which is exactly what this is meant to stop.

  // Shopify re-renders sections in the theme editor; re-mount when it does.
  document.addEventListener('shopify:section:load', mount);
})();
